import { useEffect } from "react";

// Keep the existing export so the public-site layout loads a single live chat.
export const WhatsAppButton = () => {
  useEffect(() => {
    const api = window.Tawk_API = window.Tawk_API || {};
    api.onLoad = () => {
      if (typeof api.showWidget === "function") api.showWidget();
    };
    if (typeof api.showWidget === "function") api.showWidget();

    if (!document.getElementById("controllatelefoni-tawk")) {
      window.Tawk_LoadStart = new Date();
      const script = document.createElement("script");
      script.id = "controllatelefoni-tawk";
      script.async = true;
      script.src = "https://embed.tawk.to/6abc10b63173c43446a43414/1k3na2itd";
      script.charset = "UTF-8";
      script.setAttribute("crossorigin", "*");
      document.head.appendChild(script);
    }

    return () => {
      api.onLoad = () => {
        if (typeof api.hideWidget === "function") api.hideWidget();
      };
      if (typeof api.hideWidget === "function") api.hideWidget();
    };
  }, []);

  return null;
};
